import global from 'global';
var globalWindow = global.window;
globalWindow.STORYBOOK_REACT_CLASSES = {};